module.exports = __webpack_public_path__ + "img/fav.4d21f99b.jpg";